import { Component } from '@angular/core';
import { E5coreUiWorkFieldTypeCurrencyBaseComponent } from './e5core-ui-work-field-type-currency-base';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'e5core-ui-work-field-type-currency-bootstrap',
  templateUrl: './e5core-ui-work-field-type-currency-bootstrap.component.html',
  styleUrls: ['./e5core-ui-work-field-type-currency-bootstrap.component.css']
})
export class E5coreUiWorkFieldTypeCurrencyBootstrapComponent extends E5coreUiWorkFieldTypeCurrencyBaseComponent {
  constructor(cp: CurrencyPipe) {
    super(cp) ;
  }
}

